import { Component, Input } from '@angular/core';
import { DomainStandard } from '../models/domain-standards.model';
import { StandardSetType } from '../settings/standard-set-settings.constants';

@Component({
  selector: 'app-standard-results',
  templateUrl: './standard-results.component.html',
  styleUrls: ['./standard-results.component.scss']
})
export class StandardResultsComponent {
  @Input() skillOrder: string = '';
  @Input() domainStandardSets: DomainStandard[] | null = [];

  constructor() { }

    public get isEnvision(): boolean {
      return this.skillOrder.toLowerCase().includes(StandardSetType.Envision.toLowerCase());
    }
}
